var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "10px",
  height: "8px",
  viewBox: "0 0 10 8",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.315 7.858L.133 4.441a.506.506 0 010-.684l.643-.683a.437.437 0 01.642 0l2.219 2.392L8.58.141a.437.437 0 01.643 0l.643.684a.504.504 0 010 .682l-5.91 6.351a.437.437 0 01-.642 0"
})));
export default SvgCheck;